import clientApi from '../../../api/clientApi';
import { Endpoints } from '../../../utility/constants';
import { handleError } from '.';

export const getMpiTemplateById = (templateId) => async (dispatch) => {
  dispatch({ type: 'GET_MPI_TEMPLATE_BY_ID' });

  try {
    const response = await clientApi.get(`${Endpoints.mpiTemplates}/${templateId}`);
    dispatch({ type: 'RECEIVE_MPI_TEMPLATE_BY_ID', data: response.data });
  } catch (error) {
    return dispatch(handleError(error));
  }
};

export const getMpiTemplates = () => async (dispatch) => {
  dispatch({ type: 'GET_MPI_TEMPLATES' });

  try {
    const response = await clientApi.get(Endpoints.mpiTemplates);

    // Sorts preset MPI templates to the top of lists
    response.data.results.sort((a, b) => {
      if (a.presetName && !b.presetName) return -1;
      if (!a.presetName && b.presetName) return 1;
      return 0;
    });

    dispatch({
      type: 'RECEIVE_MPI_TEMPLATES',
      data: response.data && response.data.results,
    });
  } catch (error) {
    return dispatch(handleError(error));
  }
};
